// imports
import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';
// components
import SubProductTypeSelect from 'components/common/simpleSelectors/SubProductType';
// interfaces
import { ProductSubTypesSelectorProps } from 'interfaces';

const ProductSubTypesSelector: FC<ProductSubTypesSelectorProps> = ({
  name,
  title,
  handleChange,
  productTypeId,
  ...rest
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <SubProductTypeSelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            helperText={message}
            error={Boolean(message)}
            productTypeId={productTypeId}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

export default ProductSubTypesSelector;
